import React from 'react';

import Model from './Model';
import './Model.css';

function ModelRow(props: { models: Array<Model>; key: number; i: number }) {
  return (
    <div className="row model-row page-break">
      {props.models.map((obj) => (
        <Model key={obj.id} model={obj} alignment={props.i % 2 === 1} />
      ))}
    </div>
  );
}

export default ModelRow;
